var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"thumbsCanvas",attrs:{"width":"200","height":"400"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }